// extracted by mini-css-extract-plugin
module.exports = {"gray":"#f7f7f7","orange":"#FF6620","container":"Menu_container__1u55B","list":"Menu_list__2cZBX","item":"Menu_item__2R9q5","active":"Menu_active__316d6"};